// extracted by mini-css-extract-plugin
module.exports = {"displayJobCount":"displayJobCount","displayJobCount__totalNum":"displayJobCount__totalNum","displayJobCount__perPageNum":"displayJobCount__perPageNum"};